import { useNavigate, useParams } from 'react-router-dom'
import { useCallback } from 'react'

const LOCATION_ID_SEGMENT_SOURCE = '[0-9]+'
const SYSTEM_NUMBER_SEGMENT_SOURCE = 'ssi[0-9]+'
const LOCATION_OR_SYSTEM_SEGMENT_SOURCE = `(?:${LOCATION_ID_SEGMENT_SOURCE}|${SYSTEM_NUMBER_SEGMENT_SOURCE})`
const LOCATION_PATH_WITH_OPTIONAL_IDENTIFIER_REGEX = new RegExp(`^/locations(?:/${LOCATION_OR_SYSTEM_SEGMENT_SOURCE})?(.*)$`, 'i')

export function useLocationId() {
  const { sid: locationId } = useParams()
  const navigate = useNavigate()

  /**
   * Inserts or replaces the location ID provided in the current URL path and navigates to the resulting URL.
   *
   * @param locationId The location ID to use in the target URL.
   * @param options Optional flags for URL cleanup behavior.
   */
  const setLocationIdInUrl = useCallback(
    (locationId: string | undefined, options?: { clearUrlParams?: boolean }) => {
      /* intentionally using window.location instead of useLocation here because useLocation will be 
         out of date in cases where the searchParams were updated right before calling this function. */
      const currentUrlPath = window.location.pathname
      const urlParamsSuffix = options?.clearUrlParams ? '' : `${window.location.hash}${window.location.search}`
      const newUrlPath = currentUrlPath.replace(
        LOCATION_PATH_WITH_OPTIONAL_IDENTIFIER_REGEX,
        `/locations${locationId ? `/${locationId}` : ''}$1${urlParamsSuffix}`
      )
      navigate(newUrlPath)
    },
    [navigate]
  )

  return { locationId, setLocationId: setLocationIdInUrl }
}
